module.exports = __webpack_public_path__ + "img/google.f3f528c3.svg";